import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

export const UNREAD_EVENT = "messages:unread-refresh";
export const bumpUnread = () => window.dispatchEvent(new Event(UNREAD_EVENT));

export function useUnreadCount(enabled = true, url = "/messaging/unread-count", key = "unread", extraKey = null) {
  const [count, setCount] = useState(0);
  const [extra, setExtra] = useState(0);
  const refresh = useCallback(() => { if (enabled) api.get(url).then((r) => { setCount(r.data[key] || 0); if (extraKey) setExtra(r.data[extraKey] || 0); }).catch(() => {}); else { setCount(0); setExtra(0); } }, [enabled, url, key, extraKey]);
  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 30000);
    const onFocus = () => refresh();
    window.addEventListener("focus", onFocus);
    window.addEventListener(UNREAD_EVENT, onFocus);
    return () => { clearInterval(t); window.removeEventListener("focus", onFocus); window.removeEventListener(UNREAD_EVENT, onFocus); };
  }, [refresh]);
  return extraKey ? [count, extra] : count;
}

export function UnreadBadge({ count, testid = "unread-badge", urgent = false }) {
  if (!count) return null;
  return (
    <span className={`ml-auto inline-flex min-w-[20px] h-5 items-center justify-center rounded-full px-1.5 text-[11px] font-bold shadow-[0_0_0_2px_rgba(15,23,42,1)] animate-[pulse_2s_ease-in-out_1] ${urgent ? "bg-amber-400 text-slate-900" : "bg-red-600 text-white"}`} data-testid={testid} data-urgent={urgent ? "true" : "false"} aria-label={`${count} ${urgent ? "including rush " : ""}items`} title={urgent ? "Includes RUSH requests" : undefined}>
      {count > 99 ? "99+" : count}
    </span>
  );
}
